import { ClinicalSpecialistIcon, SurgeonIcon, TxDelegateIcon } from '@icons';
import { ServiceConfirmationStyle } from '@features/components/CaseCard/Blocks/Confirmation/constants';
import cn from 'classnames';
import { ServiceConfirmationCssTypes } from '@features/components/CaseCard/Blocks/Confirmation/types';
import { specialistCssStyles, SpecialistStylesStyle } from '@features/components/CaseCard/Blocks/Base/specialistStyles';
import { ServiceApprovals } from '../../types';
import { ConfirmationCard } from './ConfirmationCard';

type ServiceConfirmationProps = {
  approvals: ServiceApprovals;
  color: string;
  style: ServiceConfirmationStyle;
};

const cssStyles: Record<ServiceConfirmationStyle, ServiceConfirmationCssTypes> = {
  [ServiceConfirmationStyle.base]: {
    labelClassNames: '',
    specialistClassNames: specialistCssStyles[SpecialistStylesStyle.base],
  },
  [ServiceConfirmationStyle.minor]: {
    labelClassNames: 'text-[#66636F]',
    specialistClassNames: specialistCssStyles[SpecialistStylesStyle.base],
  },
};

export const ServiceConfirmation = ({ approvals, color, style }: ServiceConfirmationProps) => {
  const cssStyle = cssStyles[style];
  return (
    <div className="w-full flex flex-col gap-3">
      <div className={cn('text-s-cps', cssStyle.labelClassNames)}>Service Confirmation</div>
      <div className="flex flex-col gap-2">
        <ConfirmationCard
          color={color}
          label="Retrieval Surgery"
          value={approvals.surgery?.signature?.fullName}
          icon={<SurgeonIcon height={24} width={24} />}
          cssStyles={cssStyle.specialistClassNames}
        />
        <ConfirmationCard
          color={color}
          label="OCS Management"
          value={approvals.management?.signature?.fullName}
          icon={<ClinicalSpecialistIcon height={24} width={24} />}
          cssStyles={cssStyle.specialistClassNames}
        />
        <ConfirmationCard
          color={color}
          label="TX Representative"
          value={approvals.service?.signature?.fullName}
          icon={<TxDelegateIcon height={24} width={24} />}
          cssStyles={cssStyle.specialistClassNames}
        />
      </div>
    </div>
  );
};
